import { Table } from '@flos/react-ui';

const CoverageCustomTableCell = ({
    dataHeader,
    hideDataHeader = false,
    className,
    children
}: {
    dataHeader?: string | undefined;
    hideDataHeader?: boolean;
    className?: string;
    children: React.JSX.Element | React.JSX.Element[];
}): React.JSX.Element => {
    if (dataHeader === undefined || hideDataHeader) {
        return <Table.Cell className={className}>{children}</Table.Cell>;
    }
    return (
        <Table.Cell data-header={dataHeader} className={className}>
            {children}
        </Table.Cell>
    );
};

export default CoverageCustomTableCell;
